import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { createApiRequest } from "../utils/apiClient";

const FALLBACK_BUILDINGS = [
  {
    id: 6,
    buildingName: "Union Park Alberton - Voltex",
    city: "Johannesburg",
    address: "14 Union Street Alberton North"
  },
  {
    id: 9,
    buildingName: "66 Kyalami Boulevard",
    city: "Midrand",
    address: "59 Kyalami Boulevard"
  },
  {
    id: 21,
    buildingName: "121 Gazelle Ave Corporate Park",
    city: "Midrand",
    address: "121 Gazelle Avenue"
  }
];

const useBuildings = () => {
  const [buildings, setBuildings] = useState([]);
  const [buildingsLoading, setBuildingsLoading] = useState(false);
  const [buildingsError, setBuildingsError] = useState(null);

  const fetchBuildings = async () => {
    try {
      setBuildingsLoading(true);
      setBuildingsError(null);

      const { retryOperation } = await import('../utils/networkResilience');

      const apiClient = createApiRequest();
      const response = await retryOperation(async () => {
        return apiClient.get(`/api/buildings/marketing-buildings`);
      }, {
        operationName: 'fetch_buildings',
        maxRetries: 3
      });

      setBuildings(response.data);
    } catch (error) {
      console.error("Error fetching buildings:", error);

      const { parseBackendError, getErrorMessage } = await import('../utils/errorHandling');
      const parsedError = parseBackendError(error, { operation: 'fetch_buildings' });
      const errorMessage = getErrorMessage(parsedError.type, parsedError.context);
      setBuildingsError(errorMessage.message);

      toast.error(`Failed to load buildings: ${errorMessage.message}`);
      setBuildings(FALLBACK_BUILDINGS);
    } finally {
      setBuildingsLoading(false);
    }
  };

  return {
    buildings,
    buildingsLoading,
    buildingsError,
    fetchBuildings,
    setBuildings,
  };
};

export default useBuildings;
